<template>
  <transition-group class="content" tag="ul" name="fade-list">
    <li v-for="item in list" :key="item.code" v-show="show">
      {{ item.text }}
    </li>
  </transition-group>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      list: [
        { code: 0, text: "增强孩子的计算思维能力" },
        { code: 1, text: "培养孩子的创造力" },
        { code: 2, text: "让孩子掌握未来必备技能" },
        { code: 3, text: "增强孩子解决问题的能力" },
        { code: 4, text: "培养孩子的团队合作精神" }
      ]
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    handleScroll(e) {
      const winHeight =
        e.target.scrollTop || document.documentElement.scrollTop;
      console.log(winHeight);
      if (winHeight > 180) {
        this.show = true;
      } else {
        this.show = false;
      }
    },

    beforeEnter(dom) {
      dom.classList.add("fade-list-enter-active");
    },
    enter(dom, done) {
      let delay = dom.dataset.delay;
      setTimeout(() => {
        dom.classList.remove("fade-list-enter-active");
        dom.classList.add("fade-list-enter-to");
        let transitionend = window.ontransitionend
          ? "transitionend"
          : "webkitTransitionEnd";
        dom.addEventListener(transitionend, function onEnd() {
          dom.removeEventListener(transitionend, onEnd);
          done(); //调用done() 告诉vue动画已完成，以触发 afterEnter 钩子
        });
      }, delay);
    },
    afterEnter(dom) {
      dom.classList.remove("fade-list-enter-to");
    }
  }
};
</script>

<style lang="less">
.content {
  padding: 0px;
  li {
    height: 70px;
    color: #6b7182;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #6b7182;
  }
}
.fade-list-enter-active {
  opacity: 0;
  transform: translateY(100%);
  transition: all 1.25s;
}
.fade-list-enter-to {
  opacity: 1;
  transform: translateY(0);
}
.fade-list-enter-active:nth-child(1) {
  transition-delay: 0s;
}
.fade-list-enter-active:nth-child(2) {
  transition-delay: 0.25s;
}
.fade-list-enter-active:nth-child(3) {
  transition-delay: 0.5s;
}
.fade-list-enter-active:nth-child(4) {
  transition-delay: 0.75s;
}
.fade-list-enter-active:nth-child(5) {
  transition-delay: 1s;
}
.fade-list-enter-active:nth-child(6) {
  transition-delay: 1.25s;
}
</style>



// WEBPACK FOOTER //
// src/components/TransitionText.vue